package ru.it_mozaika.sender.js.application.context

import io.ktor.client.call.*
import io.ktor.http.*
import js.core.jso
import react.*
import react.router.useParams
import ru.it_mozaika.sender.common.models.EmailTemplateData
import ru.it_mozaika.sender.common.models.TemplateType
import ru.it_mozaika.sender.js.application.Http

external interface TemplatesContextInterface{
    var templates: List<EmailTemplateData>
    var currentTemplate: EmailTemplateData?
    var currentType: TemplateType?
    var setType: (String) -> Unit
    var setCurrentTemplate:(String) -> Unit
    var clearCurrentTemplate: () -> Unit
    var reloadData: () -> Unit
    var unsubscribeTemplate: EmailTemplateData?
    var confirmTemplate: EmailTemplateData?
    var reviewTemplate: EmailTemplateData?

}

val TemplatesContext = createContext<TemplatesContextInterface>(
    jso{
        templates = listOf()
      this.currentTemplate =   null
      this.currentType = null
      this.setType = {}
        setCurrentTemplate = {}
        clearCurrentTemplate = {}
        reloadData = {}
        unsubscribeTemplate = null
        confirmTemplate = null
        reviewTemplate = null
    }
)

val TemplatesProvider = FC<PropsWithChildren>{props ->
    val requestResponse = useContext(RequestResultContext)
    val storeContext = useStore()
    val currentStore = storeContext.currentStore
    var templates by useState(listOf<EmailTemplateData>())
    var currentTemplate by useState<EmailTemplateData>()
    var currentType=  TemplateType.values().find{ type ->
        type.urlTitle == useParams()["type"]
    }
    var unsubscribeTemplate: EmailTemplateData? by useState()
    var confirmTemplate: EmailTemplateData? by useState()
    var reviewTemplate: EmailTemplateData? by useState()

    fun loadData() {
        storeContext.currentStore?.id?.let {
            Http.get("/templates", mapOf("store" to it, "type" to (currentType?.name ?: ""))) { response ->
                when (response.status) {
                    HttpStatusCode.OK -> {
                        val data = response.body<List<EmailTemplateData>>()
                        println("data - ${data.find { it.id == currentStore?.unsubscribePageId }}")
                        templates = data
                        unsubscribeTemplate = data.find{it.id == currentStore?.unsubscribePageId }
                        confirmTemplate = data.find{it.id == currentStore?.confirmationPageId }
                        reviewTemplate = data.find{it.id == currentStore?.reviewTemplateId }
                    }
                    else -> requestResponse.handleRequestRespond(response)
                }
            }
        }
    }

    useEffect(storeContext.currentStore?.id, currentType?.name){
            loadData()
    }
    useEffect(currentType){
        currentTemplate = null
    }


    TemplatesContext.Provider{
        value = jso{
            clearCurrentTemplate = {
                currentTemplate = null
            }
            this.setType = {
//                println("SetType - $it")
                currentType = TemplateType.values().find{type -> type.name == it}
            }
            this.currentType = currentType
            this.currentTemplate = currentTemplate
            this.setCurrentTemplate = {id ->
                currentTemplate = templates.find{it.id == id}
            }
            this.templates = useMemo(templates.map{it.id}.toTypedArray()){templates}
            reloadData = {
                loadData()
            }
            this.unsubscribeTemplate = unsubscribeTemplate
            this.confirmTemplate = confirmTemplate
            this.reviewTemplate = reviewTemplate
        }
        + props.children
    }
}

fun useTemplate() = useContext(TemplatesContext)